export default "__VITE_ASSET__CEts4d1___"